export default "__VITE_ASSET__818315d9__"